import React from 'react'
import { useQuery } from 'jsonapi-react'
import pluralize from 'pluralize'
import TAG_ICONS from 'app/utils/tagIcons'
import { Tag } from 'react-feather'
import ShadowBox from 'app/caterers/ShadowBox'
import styles from './TopCuisines.module.css'

export default function TopCuisines({city, areaFilter, ...rest}) {
  const tagsQuery = useQuery(['tags', {
    sort: '-total_caterers',
    filter: {
      ...areaFilter,
      primary: true,
    },
    fields: {
      tags: ['name', 'slug', 'city_map_description', 'city_description']
    },
    extra_fields: {
      tags: ['total_caterers']
    },
    page: {
      number: 1,
      size: 5,
    },
    stats: {
      total: 'count',
    }
  }])

  const tags = tagsQuery?.data
  const isLoading = tagsQuery.isLoading

  if (!tags?.length || tags.length < 1 || isLoading) {
    return null
  }

  return (
    <div {...rest}>
      <h2 className="text-navy text-4xl font-platform">Top {tags.length > 1 ? `${tags.length} Cuisines` : 'Cuisine'} in {city.name}</h2>
      {tags.slice(0,5).map(tag => (
        <TopCuisine key={tag.id} tag={tag} city={city} areaFilter={areaFilter} />
      ))}
    </div>
  )

}

function TopCuisine({tag, city, areaFilter}) {
  const caterersQuery = useQuery(['caterers', {
    sort: '-ranking',
    filter: {
      ...areaFilter,
      ...(tag.slug === 'dessert' ? { specific_tag_id: tag.id } : { tag_id: tag.id }),
      closed: false
    },
    include: [
      'photo',
    ],
    fields: {
      caterers: ['name', 'slug'],
      photos: ['uuid', 'extension', 'path']
    },
    page: {
      number: 1,
      size: 4,
    },
    stats: {
      total: 'count',
    }
  }])

  const caterers = caterersQuery?.data
  const isLoading = caterersQuery.isLoading
  const path = `/food-trucks/${city.url_slug}`

  if (!caterers?.length || isLoading) {
    return null
  }
  const parseTagCityDescription = () => {
    if (!tag.city_map_description && !tag.city_description) {
      return tag.description
    }
    let base = tag.city_map_description || tag.city_description
    base = base.replaceAll("{{CITY_NAME}}", city.name)
    base = base.replaceAll("{{REGION_NAME}}", city.region?.name)
    base = base.replaceAll("{{REGION_ABBREV}}", city.region?.code)
    base = base.replaceAll("{{COUNT}}", caterersQuery.meta.stats.total.count)
    return base
  }

  return (
    <div key={tag.id} className="my-4">
      <div className="flex items-center">
        <div style={{width:"1.5rem"}} className='flex items-center'>
          { TAG_ICONS[tag.slug] ? (
            <img src={TAG_ICONS[tag.slug]} style={{width:"1.5em"}}/>
          ) : (
            <Tag size={16}/>
          )}
        </div>
        <h3 className="font-bold text-black text-xl pl-2 my-2">{tag.name}</h3>
      </div>
      <p className="mb-4">{parseTagCityDescription(tag.city_description)}</p>
      <div className={[styles.caterers_list, "grid grid-cols-2 md:grid-cols-3 gap-5 lg:gap-6"]}>
        {caterers.map(caterer => (
          <ShadowBox
            key={caterer.id}
            caterer={caterer}
            photo={caterer.photo}
          />
        ))}
      </div>
      <div className="text-center">
        <a
          href={`${path}/${tag.slug}/`}
          className="btn btn-gray px-4 py-2 mt-4"
          children={`View all ${pluralize.singular(tag?.name)} trucks`}
        />
      </div>
    </div>
  )
}
